import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle } from '@capacitor/haptics';

export default function haptic() {
  if (Capacitor.getPlatform() === 'web' || Capacitor.getPlatform() === 'android') return;
  Haptics.impact({ style: ImpactStyle.Light });
}
